import { AxiosPromise } from "axios";
import { EngageActionPlan } from "../../types/EngageActionPlan";
import { libApiInstance } from "../axios";

export function requestEngageActionPlan(contactId: number, signal?: AbortSignal): AxiosPromise<EngageActionPlan[]> {
    return libApiInstance.get(`/contacts/${contactId}/engageactionplans`, { signal });
}

export function requestPauseActionPlan(plan: EngageActionPlan,  contactId: number,  signal?: AbortSignal): AxiosPromise<EngageActionPlan> {
    return libApiInstance.post(`/contacts/${contactId}/engageactionplans/pause`, plan, { signal });
}

export function requestResumeActionPlan(plan: EngageActionPlan,  contactId: number,  signal?: AbortSignal): AxiosPromise<EngageActionPlan> {
    return libApiInstance.post(`/contacts/${contactId}/engageactionplans/resume`, plan, { signal });
}

//TODO
export function requestAssignActionPlan(templateId: number,  contactId: number, assignedUser: number, signal?: AbortSignal): AxiosPromise<unknown> {
    return libApiInstance.post(`/contacts/${contactId}/engageactionplans/assign`, templateId, { signal });
}

export function requestTimelineActionPlan(planId: number,  contactId: number,  signal?: AbortSignal): AxiosPromise<EngageActionPlan> {
    return libApiInstance.get(`/contacts/${contactId}/engageactionplans/${planId}/timeline`, { signal });
}